module.exports = __webpack_public_path__ + "img/title-lp-text-mobile.b7d4ad7.png";